// ============================================================
// causas.js — Lista oficial de Causas de Falla, Causas de
// Incumplimiento ICR y Mapa de Agrupación.
// Importar este archivo en todos los componentes que necesiten
// estas listas.
// ============================================================

export const causasFalla = [
  "Afectación multiple",
  "Ausencia energía red comercial (Clientes sin energía no contact rate)",
  "Ausencia energía red comercial, falla sistema de respaldo eléctrico",
  "Falla corte de fibras corto eléctrico",
  "Falla en la red COAX por corto eléctrico",
  "Falla por corto eléctrico red comercial COAX",
  "Falla corte de fibras",
  "Falla corte de fibras (Desastre natural derrumbe/Caída Arboles/Inundación)",
  "Falla corte de fibras en Obras POT",
  "Falla corte de fibras podas/animales",
  "Falla corte de fibras por vandalismo",
  "Falla corte de fibras poste caído",
  "Falla corte de fibras transito vehicular",
  "Falla corte de red movimiento de infraestructura",
  "Falla en empalme hilo roto / Atenuado",
  "Afectación en Transmisión",
  "Falla en conectividad SDS",
  "Falla conectorización coax",
  "Falla corte de cable coaxial .500",
  "Falla Daño Interno Nodo Óptico",
  "Falla pasivo Corto / Humedad / Sulfatado / Roto",
  "Falla Plataforma RPHY",
  "Falla activo equipo quemado / corto",
  "Nodo bloqueado para clientes hasta que se realice cambio de nodo",
  "Falla por hurto activos en la red",
  "Falla por hurto de cable y pasivos",
  "Duración de la caida en menor tiempo",
  "Verificación de gestión NOC + OTC sin afectación",
  "Nodo no presentó caida",
  "Falla ventana electrificadora",
  "Falla ventana mejoramiento",
  "Generación de alarmas servicio migrado, sin afectación",
  "Falla después de implementar mejoramiento / proyectos",
  "Intermitencias"
];

export const causasIncumplimiento = [
  "Ausencia de energia comercial",
  "Ausencia de energia comercial masiva",
  "Causas climaticas",
  "Demora creación OT por automatismo",
  "Desabasto de materiales",
  "Desactualización Base de Datos",
  "Duración de la caida en menor tiempo",
  "Falla con alta complejidad",
  "Falta permisos de administración /Terceros",
  "Falta de permisos gobierno / Concesiones",
  "Gestión del aliado",
  "Intermitencias",
  "Multiple afectación Fibra + Coax",
  "Multiple afectación Fibra + Coax  + Hurto",
  "Multiple afectación Fibra + Coax + Vandalismo",
  "Problema gestión sin afectación",
  "Problemas de orden publico / zonas rojas",
  "Restricción de acceso por riesgo electrico",
  "Robo de red",
  "Desastre natural"
];

export const mapaAgrupacion = {
  "Afectación multiple": "Afectación multiple",
  "Ausencia energía red comercial (Clientes sin energía no contact rate)": "Ausencia energía electrificadora",
  "Ausencia energía red comercial, falla sistema de respaldo eléctrico": "Ausencia energía electrificadora",
  "Falla corte de fibras corto eléctrico": "Falla corto eléctrico (electrificadora)",
  "Falla en la red COAX por corto eléctrico": "Falla corto eléctrico (electrificadora)",
  "Falla por corto eléctrico red comercial COAX": "Falla corto eléctrico (electrificadora)",
  "Falla corte de fibras": "Falla En Fibra Optica",
  "Falla corte de fibras (Desastre natural derrumbe/Caída Arboles/Inundación)": "Falla En Fibra Optica",
  "Falla corte de fibras en Obras POT": "Falla En Fibra Optica",
  "Falla corte de fibras podas/animales": "Falla En Fibra Optica",
  "Falla corte de fibras por vandalismo": "Falla En Fibra Optica",
  "Falla corte de fibras poste caído": "Falla En Fibra Optica",
  "Falla corte de fibras transito vehicular": "Falla En Fibra Optica",
  "Falla corte de red movimiento de infraestructura": "Falla En Fibra Optica",
  "Falla en empalme hilo roto / Atenuado": "Falla En Fibra Optica",
  "Afectación en Transmisión": "Falla en Red de Transmisión",
  "Falla en conectividad SDS": "Falla en SDS",
  "Falla conectorización coax": "Falla energia red propia",
  "Falla corte de cable coaxial .500": "Falla energia red propia",
  "Falla Daño Interno Nodo Óptico": "Falla energia red propia",
  "Falla pasivo Corto / Humedad / Sulfatado / Roto": "Falla energia red propia",
  "Falla Plataforma RPHY": "Falla energia red propia",
  "Falla activo equipo quemado / corto": "Falla energia red propia",
  "Nodo bloqueado para clientes hasta que se realice cambio de nodo": "Falla energia red propia",
  "Falla por hurto activos en la red": "Falla hurto",
  "Falla por hurto de cable y pasivos": "Falla hurto",
  "Duración de la caida en menor tiempo": "Falla sistema de gestión",
  "Verificación de gestión NOC + OTC sin afectación": "Falla sistema de gestión",
  "Nodo no presentó caida": "Falla sistema de gestión",
  "Falla ventana electrificadora": "Falla ventana electrificadora",
  "Falla ventana mejoramiento": "Falla ventana mejoramiento",
  "Generación de alarmas servicio migrado, sin afectación": "Falla endogena implementación",
  "Falla después de implementar mejoramiento / proyectos": "Falla endogena implementación",
  "Intermitencias": "Intermitencias"
};